<template>

    <div>
        <span class="alarmeJeJahr" v-if="chartdata">
           <bar-chart
                   v-if="loaded"
                   :chartdata="chartdata"
                   :options="options" />
        </span>
        <div v-else-if="!chartdata && !loaded" class="text-center">
            <SpinnerImage />
        </div>
    </div>

</template>

<script>

    import axios from 'axios';
    axios.defaults.withCredentials = true;
    import BarChart from '@/components/charts/BarChart.vue'
    import SpinnerImage from "@/components/layout/SpinnerImage";

    export default {
      name: 'BarChartAlarmeJeJahr',
      components: {
        BarChart,
        SpinnerImage
      },
      props: ['customer', 'keyUser', 'subUser', 'filter'],
      data () {
        return {
          loaded: false,
          /** Daten für den Bar Chart */
          chartdata: null,
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false
              },
              title: {
                display: true,
                text: this.$t('message.charts_alarme_je_jahr')
              },
              tooltip: {
                callbacks: {
                  label: function (ctx) {
                    var label = ctx.dataset.label || '';
                    if (label) {
                      label += ': ' + ctx.parsed.y;
                    }
                    return label + ' %';
                  }
                }
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                stacked: true,
                ticks: {
                  callback: function (value) { if (Number.isInteger(value)) { return value + '%'; } },
                  stepSize: 10
                }
              },
              x: {
                stacked: true
              }
            }
          },
          /** Filter der Charts */
          filterung: {
            /** Filter nach einer Objektkategorie */
            filterObjektkategorie: null,
            /** Filter nach einer Area */
            filterArea: null
          }
        }
      },
      watch: {
        customer: function () {
          this.init();
        },
        keyUser: function () {
          this.init();
        },
        subUser: function () {
          this.init();
        },
        filter: {
          handler: function (newObj) {
            // do stuff
            this.filterung = newObj;
            this.init();
          },
          deep: true
        }
      },
      created () {

        this.init();

      },
      methods: {

        init: async function () {

          if (this.customer) this.$store.commit('setChartAvailableBarChartAlarmeJeJahr', true);
          this.loaded = false;
          if (this.customer || this.keyUser || this.subUser) {

            // ein SubUser kann ein normaler SubUser oder ein KeyUser sein der von einem anderen KeyUser hinzugefügt wurde
            var subUserId = null;
            if (this.keyUser) {
              subUserId = this.keyUser.id;
            } else if (this.subUser) {
              subUserId = this.subUser.id;
            }

            // ich brauche hier die Areas von allen Standorten des Benutzers:
            let areasAllowed = null;
            if (this.$store.getters.showAreas && this.$store.getters.showAreas.length > 0) {
              areasAllowed = this.$store.getters.showAreas.join(',');
            }

            var url     = process.env.VUE_APP_SERVER_URL + '/datenbroker/getChartDataOfBesuchsbericht';
            var params  = {
              customer_id:              this.customer ? this.customer.id : null,
              key_user_id:              this.keyUser ? this.keyUser.keyUserId : null,
              sub_user_id:              subUserId,
              mandant:                  this.keyUser ? this.keyUser.biotechCountry.name : null,
              type:                     'BAR_CHART_ALARME_JE_JAHR',
              areasAllowed:             areasAllowed,
              filterObjektkategorie:    this.filterung ? this.filterung.filterObjektkategorie : null,
              filterArea:               this.filterung ? this.filterung.filterArea : null,
              auftragsart:              this.filterung ? JSON.stringify(this.filterung.auftragsart) : null
            };

            var that = this;
            await axios({
              method: 'GET',
              params: params,
              url: url
            }).then(function (response) {

              if (response.data) {

                that.chartdata = response.data.chartdata;
                if (that.chartdata) {

                  var datasets = that.chartdata.datasets;
                  if (datasets) {

                    if (datasets[0].data[0] > 0 || datasets[1].data[0] > 0 || datasets[2].data[0] > 0 || datasets[3].data[0] > 0) {
                      if (that.customer) that.$store.commit('setChartAvailableBarChartAlarmeJeJahr', true);
                      console.log("alarme je jahr verfügbar");
                    } else {
                      console.log("alarme je jahr nicht verfügbar");
                      that.chartdata = null;
                      if (that.customer) that.$store.commit('setChartAvailableBarChartAlarmeJeJahr', false);
                    }

                  }

                } // end if that.chartdata

              }
              that.loaded = true;

            }).catch(error => {
              console.log(error);
              that.loaded = true;
            });
          }

        }

      }

    }

</script>
